import { Record } from 'immutable';

const DosRejectedCommentRecord = Record({
  rejectedBy: undefined,
  rejectedComment: undefined,
  rejectedDate: undefined,
});

class DosRejectedComment extends DosRejectedCommentRecord {}

export default DosRejectedComment;




// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/DosRejectedComment/model.js